export const toWebSocketUrl = (baseUrl) => {
  const value = String(baseUrl || "")
    .trim()
    .replace(/\/+$/, "");

  if (!value) {
    return "";
  }

  if (/^wss?:\/\//i.test(value)) {
    return value;
  }

  if (/^https:\/\//i.test(value)) {
    return `wss://${value.slice(8)}`;
  }

  if (/^http:\/\//i.test(value)) {
    return `ws://${value.slice(7)}`;
  }

  if (value.startsWith("//")) {
    return `wss:${value}`;
  }

  if (/^[a-z][a-z\d+.-]*:\/\//i.test(value)) {
    return "";
  }

  const host = value.replace(/^\/+/, "");
  const isLocalHost =
    /^(localhost|127(?:\.\d{1,3}){3}|\[::1\])(?::\d+)?(?:\/|$)/i.test(host);

  return `${isLocalHost ? "ws" : "wss"}://${host}`;
};
